<template>
  <div class="content-block">
    <FlexibeeEditor></FlexibeeEditor>
  </div>
</template>

<script>
import FlexibeeEditor from 'CORE/components/settings/sync/flexibee/editor'

export default {
    name: 'FlexibeeSyncView',
    components: {
        FlexibeeEditor,
    },
}
</script>
